<div class="modal inmodal fade in parcel-modal create-edit-parcel-modal" [ngClass]="{'show': showModal}">
    <form #form="ngForm" (ngSubmit)="onSubmit(form)" submittable autocomplete="off">
        <div class="modal-dialog ">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" (click)="hideModal()">
                        <span>×</span><span class="sr-only">Close</span>
                    </button>
                    <h4 class="modal-title">Reset User's Password</h4>
                </div>
                <div class="modal-body">
                    <!-- ___ Key Tag ___ -->
                    <div class="row m-b-sm">
                        <div class="col-md-4">
                            <label>New Password</label>
                        </div>
                        <div class="col-md-8 fourteenPixelText">
                            <input class="form-control"
                                   name="plainPassword"
                                   type="password"
                                   title="New Password"
                                   id="user_password_first"
                                   (focus)="onFocusInput($event)"
                                   (blur)="onBlurInput($event)"
                                   (input)="validate($event)"
                                   [(ngModel)]="newPassword"
                                   required>
                        </div>
                    </div>

                    <!-- ___ Purpose ___ -->
                    <div class="row m-b-sm">
                        <div class="col-md-4">
                            <label>New Password Confirmation</label>
                        </div>
                        <div class="col-md-8 fourteenPixelText">
                            <input class="form-control"
                                   name="plainPasswordConfirm"
                                   type="password"
                                   title="Confirm Password"
                                   id="user_password_second"
                                   (focus)="onFocusInput($event)"
                                   (blur)="onBlurInput($event)"
                                   (input)="validate($event)"
                                   [(ngModel)]="newPasswordConfirmation"
                                   required>
                        </div>
                    </div>

                    <div class="row text-center space-30">
                        <button type="submit" class="btn btn-primary submit-btn" [disabled]="disabledSubmit">Save</button>
                    </div>

                    <div *ngIf="isActiveFirst || isActiveSecond"
                         class="tooltip-validator"
                         [ngClass]="{'active-first': isActiveFirst, 'active-second': isActiveSecond}">
                        <div class="rules-box">
                            <h4 class="title">Password Rules</h4>
                            <p class="rules-content">Password can't contain parts of the user's full name</p>
                        </div>
                        <div class="rules-box">
                            <h4 class="title">Must Contain:</h4>
                            <ul class="rules-checklist">
                                <li class="rule length-rule" [ngClass]="{'passed': lengthPassed}">At least 6 characters</li>
                                <li class="rule uppercase-rule" [ngClass]="{'passed': upperPassed}">Uppercase Letter(s)</li>
                                <li class="rule lowercase-rule" [ngClass]="{'passed': lowerPassed}">Lowercase Letter(s)</li>
                                <li class="rule number-rule" [ngClass]="{'passed': numberPassed}">Number(s)</li>
                            </ul>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </form>
    <div class="modal-backdrop fade in" (click)="hideModal()"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/admin/user/reset-password-modal/reset-password-modal.component.html